/**
 * This file is a part of the Promvc framework.
 * 
 * (c) ThemePlexi
 * 
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { defaultLocale, localeOptions } from 'Shared/react/constants';

/**
 * Application state.
 */
const Context = {
	fetchData: {
		content: 'no content',
		errors: [],
		loading: false
	},
	models: {
		userInfo: {}
	},
	settings: {
		errors: [],
		locale: (
			localStorage.getItem( 'currentLanguage' ) &&
			localeOptions.filter( function( option ) {
				return option.id === localStorage.getItem( 'currentLanguage' );
			}).length > 0 ? localStorage.getItem( 'currentLanguage' ) : defaultLocale
		)
	}
};

/**
 * Module exports
 * @public
 */
export default Context;